import axios from "axios";

export default {
    GetUrlModulePart: () => sessionStorage.evaluationsType != 'dghnoCi' ? sessionStorage.evaluationsType : 'dghno/ci',
    GetSystemData(aoqnUserId) {
        return axios.get(`${process.env.VUE_APP_API_URL}/evaluations/SystemData/${aoqnUserId}`);
    },
    GetContextItems(aoqnUserId) {
        return axios.get(`${process.env.VUE_APP_API_URL}/evaluations/context/${aoqnUserId}`);
    },
    GetMrAttributesForTreeView(context, state, advancedQueryCriteria, type, property) {
        let postData = {};
        if (
			advancedQueryCriteria.Realtional !== null ||
            advancedQueryCriteria.MrAttributes !== null
        ) {
            postData = advancedQueryCriteria;
        }
        return axios({
            url: `${process.env.VUE_APP_API_URL}/${sessionStorage.evaluationsType}/getMrAttributesForTreeView/${context.type}/${context.id}/${type}/${property}`,
            method: "POST",
            data: postData,
        });
    },
    GetMrAttributesNationalDataForTreeView(advancedQueryCriteria, type, property) {
        let postData = {};
        if (
            advancedQueryCriteria.Realtional !== null ||
            advancedQueryCriteria.MrAttributes !== null
        ) {
            postData = advancedQueryCriteria;
        }

        return axios({
            url: `${process.env.VUE_APP_API_URL}/${sessionStorage.evaluationsType}/getMrAttributesNationalDataForTreeView/${type}/${property}`,
            method: "POST",
            data: postData,
        });
    },
    GetExcelExport(context, advancedQueryCriteria) {

        var url = `${process.env.VUE_APP_API_URL}/${this.GetUrlModulePart()}/excelexport/`;
        if (context.type != null && context.id != null) {
            url += `${context.type}/${context.id}`;
        }

        return axios({
            url: url,
            method: "POST",
            data: advancedQueryCriteria,
            responseType: "blob",
        }).then((fileResponse) => {
            // getting the filename that was set by the backend
            const filename = fileResponse.headers["content-disposition"].split(";")[1].split("=")[1].slice(1, -1);

            // to make the browser download the file and not change the current address
            // we need to emulate clicking a link to a file
            // we do that by creating and clicking a new <a> element
            // it does not actually exist in the dom, only in memory
            const url = window.URL.createObjectURL(new Blob([fileResponse.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
        });
    },
  
};
